import React from 'react';
import { useTranslation } from 'localization';
import type { ArcInfo } from 'types/arc';
import ChipAtom from '../../atoms/Chip/ChipAtom';
import { getArcHealthModifier } from '../../../utils/arc/healthUtils';
import './ArcListMolecule.scss';

export interface ArcListMoleculeProps {
  arcs: ArcInfo[];
  selectedArcId: string;
  onSelectArc: (arcId: string) => void;
}

const ArcListMolecule: React.FC<ArcListMoleculeProps> = ({
  arcs,
  selectedArcId,
  onSelectArc,
}) => {
  const { t } = useTranslation();

  return (
    <div className="arc-list">
      <div className="arc-list__header">
        <span className="arc-list__title">{t('sphereArcs.list.title')}</span>
      </div>
      <ul className="arc-list__items">
        {arcs.map((arc) => {
          const isSelected = arc.id === selectedArcId;
          const healthStatus = arc.health?.status || 'on_track';
          const arcName = arc.templateSystemName;
          const healthMod = getArcHealthModifier(healthStatus);

          const itemClass = [
            'arc-list__item',
            isSelected ? 'arc-list__item--selected' : '',
          ].filter(Boolean).join(' ');

          return (
            <li key={arc.id} className={itemClass}>
              <button
                type="button"
                className="arc-list__item-button"
                onClick={() => onSelectArc(arc.id)}
                aria-selected={isSelected}
              >
                <div className="arc-list__item-info">
                  {arc.isPrimary && (
                    <span className="arc-list__primary-star" title={t('sphereArcs.primaryBadge')}>
                      ★
                    </span>
                  )}
                  <span className="arc-list__item-name">{arcName}</span>
                </div>
                <ChipAtom
                  label={t(`arc.health.${healthStatus}`)}
                  className={healthMod ? `arc-list__health-chip arc-list__health--${healthMod}` : 'arc-list__health-chip '}
                />
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ArcListMolecule;
